<template>
  <sp-text :type="tag" :tag="tag" class="sp-heading">
    <slot />
  </sp-text>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  level: {
    type: [Number, String],
    validator: (value) => Number(value) >= 1 && Number(value) <= 6,
    default: 1,
  },
});

const tag = computed(() => `h${Number(props.level)}`);
</script>

<style>
:host {
  display: block;
}
</style>
